import { ButtonBase, Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";

import { ShiftDoublePill } from "./Pill";

interface ShiftDoubleFooterProps {
  companionCount?: number;
  onClick?: () => void;
}

export function ShiftDoubleFooter(props: ShiftDoubleFooterProps) {
  const { companionCount = 1, onClick } = props;

  const label = companionCount > 1 ? `${companionCount} doubles available` : "View double \u2192";

  return (
    <ButtonBase
      sx={(theme) => ({
        width: "100%",
        textAlign: "left",
        display: "block",
        backgroundColor: theme.palette.shift?.double?.footerBackground,
        borderBottomLeftRadius: "inherit",
        borderBottomRightRadius: "inherit",
      })}
      onClick={(event) => {
        event.stopPropagation();
        onClick?.();
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ paddingX: 5, paddingY: 4 }}
      >
        <ShiftDoublePill />
        <Text
          semibold
          variant="body2"
          sx={(theme) => ({
            color: theme.palette.shift?.double?.footerText,
          })}
        >
          {label}
        </Text>
      </Stack>
    </ButtonBase>
  );
}
